/** Box height along the vertical connector axis (local Y before rotation). */
export const CONNECTOR_BOX_HEIGHT = 0.4

/** Vertical offset from the anchor point to the box center. */
export const CONNECTOR_BOX_OFFSET = 0.08

/** Plan size along the wall tangent (local X). */
export const CONNECTOR_BOX_WIDTH_ALONG_WALL = 0.08

export const CONNECTOR_GAP_WIDTH = 0.02

/** Plan size perpendicular to the wall (local Z). 
    Note: consider this together with the width of the stiffening segments
    otherwise there is z fighting in the scene
*/
export const CONNECTOR_BOX_DEPTH = 0.02
